import { parseTemplateContent } from './templateEditorFontSize';

/**
 * Converts stored template HTML (possibly wrapped in the font-size div from
 * wrapTemplateContent, and possibly truncated mid-tag by a backend LEFT(...) preview
 * query) into a single-line plain-text snippet, for list-row previews.
 */
export function htmlToPlainText(html, maxLength = 160) {
  const raw = (html || '').trim();
  if (!raw) return '';

  const { html: unwrapped } = parseTemplateContent(raw);
  const source = unwrapped || raw;

  let text;
  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(source, 'text/html');
    text = doc.body.textContent || '';
  } else {
    text = source.replace(/<[^>]*>/g, ' ');
  }

  text = text.replace(/\s+/g, ' ').trim();

  if (text.length > maxLength) {
    return `${text.slice(0, maxLength).trimEnd()}...`;
  }
  return text;
}
